export default {
  dataView: 'Visualização de dados',
  close: 'Fechar',
  refresh: 'Atualizar',
  saveAsImage: 'Salvar como imagem',
  selectAll: 'Selecionar tudo',
  invert: 'Inverter'
}
